import dayjs from 'dayjs';

import utc from 'dayjs/plugin/utc';

import timezone from 'dayjs/plugin/timezone'; // dependent on utc plugin
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(quarterOfYear)
export default  dayjs
